import React from 'react'
import CoreValueCard from '../components/CoreValueCard'

export default function CoreValues() {

const coreValuesData = [
  {
    title: "Quality of Care",
    description:
      "We are committed to delivering the highest standard of care in everything we do, ensuring safety, compassion, and excellence.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-5 h-5"
        viewBox="0 0 24 24"
      >
        <path d="M12 21C12 21 4 13.5 4 8.5C4 5.42 6.42 3 9.5 3C11.24 3 12.91 3.81 13.99 5.08C15.07 3.81 16.74 3 18.5 3C21.58 3 24 5.42 24 8.5C24 13.5 16 21 16 21H12Z" />
      </svg>
    ),
    link: "#",
  },
  {
    title: "Financial Responsibility",
    description:
      "We value transparency and accountability, ensuring financial practices that support long-term growth and trust.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-5 h-5"
        viewBox="0 0 24 24"
      >
        <path d="M12 8c-3.31 0-6 2.24-6 5s2.69 5 6 5 6-2.24 6-5-2.69-5-6-5zm0-5v2m0 14v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M1 12h2m18 0h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
      </svg>
    ),
    link: "#",
  },
  {
    title: "Empathy",
    description:
      "We listen with compassion, understand perspectives, and act with kindness to build meaningful connections.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-5 h-5"
        viewBox="0 0 24 24"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3z" />
      </svg>
    ),
    link: "#",
  },
  {
    title: "Learning",
    description:
      "We embrace continuous learning and innovation, encouraging curiosity and growth for our teams and communities.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-5 h-5"
        viewBox="0 0 24 24"
      >
        <path d="M12 2L2 7h20L12 2z" />
        <path d="M2 7v7c0 5 10 9 10 9s10-4 10-9V7" />
      </svg>
    ),
    link: "#",
  },
  {
    title: "Integrity",
    description:
      "We uphold honesty, fairness, and ethical principles in all decisions and actions, even when no one is watching.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-5 h-5"
        viewBox="0 0 24 24"
      >
        <path d="M12 2l7 7-7 13-7-13 7-7z" />
      </svg>
    ),
    link: "#",
  },
  {
    title: "Inclusion",
    description:
      "We celebrate diversity, foster belonging, and create opportunities where every voice matters and thrives.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        className="w-5 h-5"
        viewBox="0 0 24 24"
      >
        <circle cx="12" cy="12" r="10" />
        <path d="M8 12h8M12 8v8" />
      </svg>
    ),
    link: "#",
  },
]


  return (
    <div className='mx-auto px-10 md:px-20 mt-20' >
        <div className="text-center text-3xl text-secondary font-bold">Our Core Values</div>
        <div className="text-light text-sm w-1/2 text-gray-500 text-center mx-auto mt-3">
          Our values guide our mission and shape every decision we make to ensure
        care, trust, and long-term sustainability.
        </div>

        <div className='mt-8'>
            <section className="text-gray-600 body-font mt-8">
          <div className="container px-5 py-12 mx-auto">
            <div className="flex flex-wrap -m-4">
              {coreValuesData.map((item, idx) => (
                <CoreValueCard
                  key={idx}
                  {...item}
                  bgClass={idx === 0 ? 'bg-secondary bg-opacity-90 text-gray-100 ' : 'bg-tertiary bg-opacity-10'}
                />
              ))}
            </div>
          </div>
        </section>
        </div>
    </div>
  )
}
